import React from 'react';
import PropTypes from 'prop-types';
import Form from './Form';

const New = ({
  isModalOpen,
  onCloseHandler,
  onSubmitHandler,
  onMasterTypeChange,
  error,
  submitting,
  productOptions,
  productsLoading,
  affectedOptedOutParties,
  hasAnyMasterOnSide,
  createdMaster,
}) => (
  <Form
    isModalOpen={isModalOpen}
    onCloseHandler={onCloseHandler}
    onSubmitHandler={onSubmitHandler}
    onMasterTypeChange={onMasterTypeChange}
    error={error}
    submitting={submitting}
    productOptions={productOptions}
    productsLoading={productsLoading}
    affectedOptedOutParties={affectedOptedOutParties}
    hasAnyMasterOnSide={hasAnyMasterOnSide}
    createdMaster={createdMaster}
    action='new'
  />
);

New.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  // Switching payer side re-queries eligibility: the answer differs per side,
  // because one product can carry a buyer master and a seller master at once.
  onMasterTypeChange: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  productOptions: PropTypes.array,
  productsLoading: PropTypes.bool,
  // How many parties are currently opted out of EVERY master on this side. They
  // start being charged again when a new master is added, without anybody
  // touching their opt-out rows, so the count belongs on the create form.
  affectedOptedOutParties: PropTypes.number,
  // Tells apart "every eligible product on this side already has a master"
  // from "this side has never had one" (empty allowlist) — both look like an
  // empty productOptions, and only the container's already-loaded masters
  // list can tell them apart.
  hasAnyMasterOnSide: PropTypes.bool,
  // Set once create succeeds; its presence is what flips Form from the
  // side/product/price fields into the rules-review step for the new master.
  createdMaster: PropTypes.shape({
    id: PropTypes.string,
    masterType: PropTypes.string,
  }),
};

New.defaultProps = {
  isModalOpen: false,
  onMasterTypeChange: null,
  error: null,
  submitting: false,
  productOptions: [],
  productsLoading: false,
  affectedOptedOutParties: 0,
  hasAnyMasterOnSide: false,
  createdMaster: null,
};

export default New;
